<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    badgeText?: string | number | null
    element?: string
    path?: string | null
    title: string
    titleClass?: string | null
  }>(),
  { badgeText: null, element: 'h1', path: null, titleClass: null }
)
</script>

<template>
  <div class="heading mb-4 flex flex-wrap items-center justify-between">
    <div :class="{ 'flex items-start': badgeText !== null }">
      <component :is="element" class="!mb-2" :class="titleClass">
        <NuxtLink v-if="path" class="text-inherit" :to="path">
          {{ title }}
        </NuxtLink>
        <template v-else>
          {{ title }}
        </template>
      </component>

      <span
        v-show="badgeText !== null"
        class="heading__badge flex items-center justify-center whitespace-nowrap text-white"
      >{{ badgeText }}</span>
    </div>

    <div v-if="$slots.buttons" class="!mb-2">
      <div class="heading__buttons -mb-2 flex flex-wrap">
        <slot name="buttons" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use 'sass:color';

@use 'assets/css/variables';

.heading {
  &__badge {
    background: color.mix(variables.$main-gray-color, white, 50%);
    border-radius: .75em;
    box-sizing: border-box;
    font-size: 16px;
    font-weight: 400;
    line-height: 8px;
    margin-left: .5em;
    min-width: 1.5em;
    padding: .5em;

    @media screen and (max-width: 600px) {
      font-size: 12px;
      line-height: 6px;
    }
  }

  &__buttons > :deep(*) {
    margin-bottom: 8px;
    margin-right: 8px;

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
